import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button, Input, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { Mc2EntityStore } from "../Mc2EntityStore";
import { Mc2EntitySizeLineModal } from "./Mc2EntitySizeLineModal";

interface PropsMc2EntitySizeLine {
  store: Mc2EntityStore;
}

export const Mc2EntitySizeLine: React.FC<PropsMc2EntitySizeLine> = observer(
  ({ store }) => {
    const { mcEntity } = store;
    const { sizeLineName } = mcEntity;
    return (
      <Space.Compact style={{ width: "100%" }}>
        <Input disabled readOnly value={sizeLineName ?? ""} />
        {!store.readOnly && (
          <Button
            icon={<SettingOutlined />}
            disabled={store.buzy}
            onClick={() => {
              store.setMode("mapSizes");
            }}
          />
        )}
        <Mc2EntitySizeLineModal
          open={store.mode === "mapSizes"}
          close={() => store.setMode(null)}
          initialData={store.initialSizeMapData}
          settings={store.settings}
          onChange={(data) => store.doSizesMap(data)}
          saving={store.taskType === "mapSize"}
          sizeLineAttrNameId={store.sizeLineAttrNameId}
        />
      </Space.Compact>
    );
  },
);
